module.exports = __webpack_public_path__ + "static/booth_collage-1deb6dbe9a439ffcac76e4b401d91f9d.jpg";